import { WorkPlace } from "../../../types/work-place/work-place";
import { WorkPlaceDto } from "../../../types/work-place/work-place-dto";

export const convertWorkPlaceDtoToWorkPlace = (
  workPlaceDto: WorkPlaceDto
): WorkPlace => {
  return {
    name: workPlaceDto.name,
    floor: workPlaceDto.floor,
    phone: workPlaceDto.phone,
    detail: workPlaceDto.detail,
    alias: workPlaceDto.alias,
  };
};
